import { BrandManufacturerEndPoints, pageNo } from "../../config";
import { getQueryStringFrmObject, postApi, getApi, deleteApi } from "../helpers/utility";

class BrandManufacturerApi {
  create = async (masterPojo) => {
    console.log("masterpojo", masterPojo);
    if (masterPojo) {
      //   console.log("BrandManufacturer pojo", JSON.stringify(masterPojo));
      var result = await postApi(BrandManufacturerEndPoints.add, masterPojo);
      return result;
    }
  };

  read = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = BrandManufacturerEndPoints.list + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };
  readMapping = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = BrandManufacturerEndPoints.mappingList + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };

  findById = async (masterId) => {
    var result = await getApi(BrandManufacturerEndPoints.findById, masterId);
    return result;
  };

}
export default new BrandManufacturerApi();
